export default "__VITE_ASSET__CFBmQ37O__"